import { makeInstaller } from '@vuemap/vue-amap';
import Components from './component';

export default makeInstaller([...Components]);
